import {
  Badge,
  Box,
  Button,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { CustomeDialog, InputControl, Loader } from "../../../shared";
import AddIcon from "@mui/icons-material/Add";
import emptyIcon from "../../../assets/images/Icons/search-table.png";
import CloseIcon from "@mui/icons-material/Close";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { SubCategoryProductsDialog } from "./SubCategoryProductsDialog";
import SearchIcon from "@mui/icons-material/Search";

const StyledBadge = styled(Badge)(({ background, color = "text.primary" }) => ({
  "& .MuiBadge-badge": {
    right: 4,
    top: 10,
    padding: "0 4px",
    position: "relative",
    background,
    color,
  },
}));

export const CategoryAndSubCategoryTable = (props) => {
  const {
    handleClickOpen,
    onSelectItem,
    onDelete,
    searchHandler,
    category,
    isLoading,
    onDragEnd,
    onSubCategoryDragEnd,
    handleProductDialogOpen,
    ColorButton,
    onCategoryProductOrderChange,
    handleProductSortOrder,
    onSearchChange,
    recipeListQuery,
    isCreateVisible,
    isSubCategoryCreateVisible,
    isSubCategoryEditable,
    isSubCategoryDeletable,
    isEditable,
    isDeletable,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [handleClickOpenId, setHandleClickOpenId] = useState(0);
  const [isSubItem, setIsSubItem] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);

  const onSearchFocusChange = () => {
    setIsSearchActive(!isSearchActive);
  };

  const handleClick = (event, id, isSubItem) => {
    setAnchorEl(event.currentTarget);
    setHandleClickOpenId(id);
    setIsSubItem(isSubItem);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setHandleClickOpenId(0);
    setIsSubItem(isSubItem);
  };

  const onEditAction = () => {
    handleClickOpen(true, handleClickOpenId, isSubItem);
    setAnchorEl(null);
    setHandleClickOpenId(0);
  };

  const onDeleteAction = () => {
    onDelete(handleClickOpenId, isSubItem);
    setAnchorEl(null);
    setHandleClickOpenId(0);
  };

  return (
    <>
      <Box
        sx={{
          borderRadius: "4px",
          bgcolor: "background.paper",
        }}
      >
        <Stack
          flexDirection="row"
          minHeight={"calc(100vh - 165px)"}
          flexWrap="wrap"
        >
          <Box
            sx={{
              borderRight: "1px solid",
              borderColor: "divider",
              flex: 1,
            }}
          >
            {/* Header */}
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                p: "8px",
                backgroundColor: "#E6EEF7",
                flexShrink: 0,
              }}
            >
              <Typography
                fontWeight={600}
                fontSize="14px"
                color="#111C2B"
                sx={{
                  display: "flex",
                  gap: "4px",
                  flexShrink: 0,
                }}
              >
                Category Name
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                {isSearchActive ? (
                  <InputControl
                    type="table-search"
                    placeholder="Search"
                    endAdornment={
                      category.search && (
                        <InputAdornment
                          sx={{ cursor: "pointer" }}
                          position="end"
                        >
                          <CloseIcon
                            size="small"
                            onClick={() => {
                              searchHandler({ target: { value: "" } });
                              onSearchFocusChange();
                            }}
                          />
                        </InputAdornment>
                      )
                    }
                    onChange={searchHandler}
                    value={category?.search}
                    onBlur={
                      category?.search?.length > 0
                        ? undefined
                        : onSearchFocusChange
                    }
                  />
                ) : (
                  <SearchIcon
                    size="small"
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={onSearchFocusChange}
                  />
                )}

                {isCreateVisible && (
                  <Button
                    type="button"
                    size="small"
                    variant="contained"
                    color="white"
                    startIcon={<AddIcon />}
                    onClick={() => handleClickOpen(true)}
                  >
                    Category
                  </Button>
                )}
              </Box>
            </Stack>

            {isLoading ? (
              <Stack
                alignItems="center"
                gap="8px"
                padding="32px 0"
                position="relative"
                top="30%"
              >
                <Loader />
              </Stack>
            ) : category?.item && category?.item.length > 0 ? (
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable-list">
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {category?.item?.map((item, index) => {
                        const selected =
                          category?.selectedItem?.id === item?.id;
                        return (
                          <Draggable
                            key={item?.id}
                            draggableId={item?.id.toString()}
                            index={index}
                          >
                            {(provided) => (
                              <Stack
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                sx={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  borderBottom: "1px solid #DFE8F2",
                                  p: "8px",
                                  cursor: "pointer",
                                  backgroundColor: selected && "primary.main",
                                  "&:hover": {
                                    backgroundColor: (theme) =>
                                      selected
                                        ? theme.palette.primary.main
                                        : theme.palette.action.hover,
                                  },
                                  minHeight: "40px",
                                }}
                                onClick={() => onSelectItem(item, false)}
                              >
                                <Stack
                                  direction="row"
                                  gap="4px"
                                  alignItems="center"
                                  minWidth="250px"
                                >
                                  <img
                                    alt="drag"
                                    src="/icons/ic_drag.svg"
                                    style={{
                                      filter: selected
                                        ? "invert(1) brightness(2)"
                                        : "",
                                    }}
                                  />
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="subtitle2"
                                    color={selected ? "#fff" : "#111C2B"}
                                    lineHeight="18px"
                                    fontWeight={500}
                                  >
                                    {item.name}
                                  </Typography>
                                  {!!item.subcategories && (
                                    <StyledBadge
                                      badgeContent={item.subcategories}
                                      background="#0909091A"
                                      color={selected ? "#FFFF" : undefined}
                                    />
                                  )}
                                </Stack>
                                {(isEditable || isDeletable) && (
                                  <IconButton
                                    size="small"
                                    aria-label="more"
                                    sx={{ p: 0 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClick(e, item?.id, false);
                                    }}
                                  >
                                    <MoreHorizIcon
                                      fontSize="small"
                                      color={selected ? "white" : "gray"}
                                    />
                                  </IconButton>
                                )}
                              </Stack>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            ) : (
              <Stack
                alignItems="center"
                gap="8px"
                padding="32px 0"
                position="relative"
                top="30%"
              >
                <img src={emptyIcon} alt="empty" height={56} width={56} />
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "text.secondary",
                  }}
                >
                  {category?.search
                    ? "No matches found"
                    : "There is no category added yet, You need to add category first"}
                </Typography>
              </Stack>
            )}
          </Box>

          <Box
            sx={{
              flex: 1,
            }}
          >
            {/* Header */}
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                p: "8px",
                backgroundColor: "#E6EEF7",
              }}
            >
              <Typography
                fontWeight={600}
                fontSize="14px"
                color="#111C2B"
                sx={{
                  display: "flex",
                  gap: "4px",
                  flexShrink: 0,
                }}
              >
                Sub Category Name
              </Typography>
              {isSubCategoryCreateVisible && (
                <Button
                  type="button"
                  size="small"
                  variant="contained"
                  color="white"
                  disabled={category?.selectedItem?.id <= 0}
                  startIcon={<AddIcon />}
                  onClick={() => handleClickOpen(true, null, true)}
                >
                  Sub Category
                </Button>
              )}
            </Stack>

            <DragDropContext onDragEnd={onSubCategoryDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {category?.selectedItem?.subData?.length ? (
                      category?.selectedItem?.subData?.map((data, index) => (
                        <Draggable
                          key={data?.id}
                          draggableId={data?.id.toString()}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <Stack
                              onClick={() =>
                                handleProductDialogOpen(
                                  true,
                                  data?.id,
                                  data?.name
                                )
                              }
                            >
                              <Stack
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                sx={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  borderBottom: "1px solid",
                                  borderColor: "divider",
                                  p: "8px",
                                  cursor: "pointer",
                                  backgroundColor: (theme) =>
                                    snapshot.isDragging
                                      ? theme.palette.action.focus
                                      : "#FFFFFF",
                                  "&:hover": {
                                    backgroundColor: (theme) =>
                                      theme.palette.action.hover,
                                  },
                                  minHeight: "40px",
                                }}
                                onClick={() => onSelectItem(data, true)}
                              >
                                <Stack
                                  direction="row"
                                  gap="4px"
                                  alignItems="center"
                                  minWidth="250px"
                                >
                                  <img alt="icon" src="/icons/ic_drag.svg" />
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="subtitle2"
                                    lineHeight="18px"
                                    fontWeight={500}
                                  >
                                    {data.name}
                                  </Typography>
                                  {data.recipeCount !== 0 && (
                                    <StyledBadge
                                      badgeContent={data.recipeCount}
                                      background="#0909091A"
                                    />
                                  )}
                                </Stack>
                                <Stack
                                  direction="row"
                                  gap="4px"
                                  alignItems="center"
                                >
                                  {(isSubCategoryEditable ||
                                    isSubCategoryDeletable) && (
                                    <IconButton
                                      aria-label="more"
                                      sx={{ p: "0" }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClick(e, data?.id, true);
                                      }}
                                    >
                                      <MoreHorizIcon
                                        fontSize="small"
                                        color="gray"
                                      />
                                    </IconButton>
                                  )}
                                  <img
                                    alt="details"
                                    src="/icons/arrow_forward.png"
                                    style={{ cursor: "pointer" }}
                                  />
                                </Stack>
                              </Stack>
                            </Stack>
                          )}
                        </Draggable>
                      ))
                    ) : (
                      <Stack
                        alignItems="center"
                        justifyContent="center"
                        gap="8px"
                        padding="32px 0"
                        minHeight="calc(100vh - 250px)"
                      >
                        <img
                          src={emptyIcon}
                          alt="empty"
                          height={56}
                          width={56}
                        />
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "#485364",
                          }}
                        >
                          {category?.search
                            ? "No matches found"
                            : "There is no subcategory added yet, You need to add category first"}
                        </Typography>
                      </Stack>
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Box>

          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            sx={{
              "& .MuiMenu-paper": {
                minWidth: "188px",
                boxShadow: "none",
                border: "1px solid #E6EEF7",
              },
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            {(isSubCategoryEditable || isEditable) && (
              <MenuItem className="popover-menuitem" onClick={onEditAction}>
                <img alt="edit" src="/icons/ic_edit.svg" />
                Edit
              </MenuItem>
            )}
            {(isSubCategoryDeletable || isDeletable) && (
              <MenuItem className="popover-menuitem" onClick={onDeleteAction}>
                <img alt="delete" src="/icons/ic_trash.svg" />
                Delete
              </MenuItem>
            )}
          </Menu>
        </Stack>
      </Box>

      <CustomeDialog
        PaperProps={{
          sx: {
            width: "650px",
            height: "650px",
            maxHeight: "500px",
            minHeight: "200px",
          },
        }}
        closeIcon={false}
        open={category.isProductDialog}
        handleClose={(e) => {
          handleProductDialogOpen(false);
        }}
        isHeader={false}
        content={
          <SubCategoryProductsDialog
            handleModal={handleProductDialogOpen}
            ColorButton={ColorButton}
            productsList={recipeListQuery?.data?.data}
            onCategoryProductOrderChange={onCategoryProductOrderChange}
            handleProductSortOrder={handleProductSortOrder}
            onSearchChange={onSearchChange}
            recipeListQuery={recipeListQuery}
            category={category}
          />
        }
      />
    </>
  );
};
